import { View, Text } from "react-native";
import { palladium } from "../../StyleHelpers";
import ComponentThemeType from "../../models/ComponentTheme";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import TouchableButton from "../TouchableButton";
import H4 from "../Typography/H4";
import H5 from "../Typography/H5";
import ImgProgressBar from "../Loaders/ImgProgressBar";
import { StyledButton, StyledGroupContainer, StyledLoadBody, StyledLoadHeader, StyledTextContainer, StyledTextGroup } from "./styled";
import { GroupProps } from "./model";

const GroupContainer = ({ header, body, hideButton, buttonText, onPress }: GroupProps) => {
	const showLoading = !body;
	const showContent = body && header;

	return (
		//@ts-ignore
		<StyledGroupContainer>
			{showContent ? (
				<View>
					<Text>
						<H4>{header}</H4>
					</Text>
					<Text>
						<H5 fontColor={palladium}>
							{/* @ts-ignore */}
							<StyledTextContainer>
								{/* @ts-ignore */}
								<StyledTextGroup>{body}</StyledTextGroup>
							</StyledTextContainer>
						</H5>
					</Text>
				</View>
			) : (
				<></>
			)}

			{showLoading ? (
				<View>
					{/* @ts-ignore */}
					<StyledLoadHeader>
						<ImgProgressBar />
					</StyledLoadHeader>
					{/* @ts-ignore */}
					<StyledLoadBody>
						<ImgProgressBar />
					</StyledLoadBody>
				</View>
			) : (
				<></>
			)}

			{!hideButton ? (
				//@ts-ignore
				<StyledButton>
					<TouchableButton componentTheme={ComponentThemeType.VinFast} type={ComponentTypeEnum.Secondary} onPress={onPress}>
						{buttonText}
					</TouchableButton>
				</StyledButton>
			) : (
				<></>
			)}
		</StyledGroupContainer>
	);
};

export default GroupContainer;
